'use client';

import { useState, type ReactNode } from 'react';

import { SaleApplicationForm } from '../sale-application-form';
import { SaleBenefitsHeader } from '../sale-benefits-header';
import { SaleConnectionAccepted } from '../SaleConnectionAccepted';
import {
  isSellerSalesAccessGranted,
  useSellerProfileQuery,
} from '@/features/original-sale/hooks/use-seller-profile-query';

interface DashboardSaleConnectionContentProps {
  walletContent: ReactNode;
}

const isSaleApplicationAwaitingModeration = (
  isSubmitted: boolean,
  applicationStage: number | undefined,
  status: string | null | undefined,
): boolean => isSubmitted || (applicationStage === 2 && status === 'new');

export const DashboardSaleConnectionContent = ({
  walletContent,
}: DashboardSaleConnectionContentProps) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { profile } = useSellerProfileQuery();

  if (isSellerSalesAccessGranted(profile)) {
    return walletContent;
  }

  if (
    isSaleApplicationAwaitingModeration(isSubmitted, profile?.applicationStage, profile?.status)
  ) {
    return (
      <div className="max-w-[620px] mx-auto py-6">
        <SaleConnectionAccepted />
      </div>
    );
  }

  return (
    <div className="max-w-[620px] mx-auto py-6 space-y-10">
      <SaleBenefitsHeader />
      <SaleApplicationForm profile={profile} onSuccess={() => setIsSubmitted(true)} />
    </div>
  );
};
